<template>
  <f7-page class="page-setup-storage">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>THỜI GIAN LƯU TRỮ</f7-nav-title>
    </f7-navbar>
    <f7-block inset strong>
      <p>
        Dữ liệu sẽ tự động xóa sau :
      </p>
      <ul class="list-style-none pl-1">
        <li class="mb-1">
          <label>
            <f7-checkbox @change="configs.days_keep_data = 1" :checked="configs.days_keep_data === 1"></f7-checkbox>
            1 Ngày
          </label>
        </li>
        <li class="mb-2">
          <label>
            <f7-checkbox @change="configs.days_keep_data = 3" :checked="configs.days_keep_data === 3"></f7-checkbox>
            3 Ngày
          </label>
        </li>
        <li class="mb-1">
          <label>
            <f7-checkbox @change="configs.days_keep_data = 7" :checked="configs.days_keep_data === 7"></f7-checkbox>
            1 Tuần
          </label>
        </li>
        <li class="mb-2">
          <label>
            <f7-checkbox @change="configs.days_keep_data = 14" :checked="configs.days_keep_data === 14"></f7-checkbox>
            2 Tuần
          </label>
        </li>
        <li class="mb-1">
          <label>
            <f7-checkbox @change="configs.days_keep_data = 30" :checked="configs.days_keep_data === 30"></f7-checkbox>
            1 Tháng
          </label>
        </li>
        <li class="mb-1">
          <label>
            <f7-checkbox @change="configs.days_keep_data = 60" :checked="configs.days_keep_data === 60"></f7-checkbox>
            2 Tháng
          </label>
        </li>
      </ul>
    </f7-block>
    <f7-block inset>
      <f7-button fill color="primary" @click.prevent="submitChangeConfig" class="mb-2">
        LƯU THÔNG TIN
      </f7-button>
      <f7-button fill color="gray" @click.prevent="deleteMessages">
        XÓA DỮ LIỆU
      </f7-button>
    </f7-block>
  </f7-page>
</template>
<script>
import {mapState} from 'vuex';

export default {
  computed  :{
    ...mapState(['user_info'])
  },
  data(){
    return {
      configs:{}
    }
  },
  methods:{
    submitChangeConfig(){
      this.$f7.preloader.show();
      this.$store.dispatch('changeMeConfig', this.configs)
          .then(() => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert('Đã cập nhật thành công', 'THÔNG BÁO', () => {
              this.user_info.user_configs = this.configs;
            })
          })
          .catch((err) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(err, 'LỖI!');
          })
    },
    deleteMessages(){
      const self = this;
      let from_date = self.$moment().subtract(2, 'months').format('YYYY-MM-DD');
      let to_date = self.$moment().add(7, 'day').format('YYYY-MM-DD');

      self.$f7.dialog.confirm('Bạn có chắc chắn muốn xóa toàn bộ dữ liệu?', 'CẢNH BÁO!', () => {
        self.$f7.preloader.show();
        self.$store.dispatch('deleteMessages', {
          from_date:from_date,
          to_date  :to_date
        })
            .then(() => {
              self.$f7.preloader.hide();
              self.$f7.dialog.alert('Đã xóa dữ liệu', 'THÔNG BÁO');
            })
            .catch((err) => {
              self.$f7.preloader.hide();
              self.$f7.dialog.alert(err, 'LỖI!');
            })
      });
    }
  },
  mounted(){
    this.configs = this.user_info.user_configs;
  }
};
</script>
